{
  "legal": {
    "meta": {
      "title": "Información legal - MAJORITY",
      "description": "Consulta nuestros Términos y condiciones, Política de privacidad y más."
    },
    "hero": {
      "title": "Términos de uso"
    },
    "sections": {
      "majority": "MAJORITY",
      "partners": "Colaboradores",
      "banking_and_card": "Banca y tarjeta",
      "miscellaneous": "Misceláneas"
    }
  }
  
}